import React from "react";
import { slide4Logic, useStyles } from "./slide4.module";



export default function Slide4() {
    const classes= useStyles();
    const {translator}= slide4Logic();
    return(
        <>
            <div className={classes.container}>
                <p className={classes.text}><span className={classes.comingSoon}>{translator('slide4.coming_soon')} </span>{translator('slide4.text')}</p>
            </div>
        </>
    )
}